export const BRANDING_UPDATED_EVENT = 'niraxobid_branding_updated';

export function notifyBrandingUpdated(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(BRANDING_UPDATED_EVENT));
  }
}

/** Organization logo is stored in the database. Returns null as localStorage is not used. */
export function getStoredOrganizationLogo(): string | null {
  return null;
}

/** No-op for localStorage storage to ensure images are persisted in the database only. */
export function setStoredOrganizationLogo(_logo: string | null): void {
  try {
    localStorage.removeItem('niraxobid_org_logo');
    notifyBrandingUpdated();
  } catch {
    /* storage unavailable */
  }
}

/** Login image is stored in the database. Returns null as localStorage is not used. */
export function getStoredLoginImage(): string | null {
  return null;
}

/** No-op for localStorage storage to ensure images are persisted in the database only. */
export function setStoredLoginImage(_image: string | null): void {
  try {
    localStorage.removeItem('niraxobid_login_image');
    notifyBrandingUpdated();
  } catch {
    /* storage unavailable */
  }
}
